import { Lock } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Typography } from '@/components/ui/typography';
import { landingCopy as copy } from '../landing/copy';

interface Props {
  /** The vendor whose page was requested. */
  vendorName: string;
  /** The vendor the organization is actually connected to. */
  connectedVendorName: string;
  onBack: () => void;
}

/**
 * Shown on /vendor/:id when the org's PMS connection belongs to a different
 * vendor (spec §4.7). Replaces the red "You don't have access" alert; never a
 * redirect, so a deep link explains itself. Centered 560 px card per the
 * Integrations Redesign prototype.
 */
export const LockedVendorCard = ({ vendorName, connectedVendorName, onBack }: Props) => (
  <Card className="mx-auto my-12 max-w-[560px] rounded-xl shadow-none">
    <CardContent className="flex flex-col items-center gap-3 p-8 text-center">
      <div className="flex size-12 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <Lock className="size-5.5" aria-hidden="true" />
      </div>
      <Typography as="h2" variant="heading-md">{copy.lock.title(vendorName)}</Typography>
      <Typography as="p" variant="body" className="text-muted-foreground">
        {copy.lock.body(connectedVendorName)}
      </Typography>
      <Button type="button" variant="outline" className="mt-2" onClick={onBack}>{copy.lock.back}</Button>
    </CardContent>
  </Card>
);
